export default "__VITE_ASSET__BGZolFtO__"